import React, { useState, useEffect } from "react";
import Restart from "../restart/restart"; // Import the Restart component

import "./eventoptions.scss";

const EventOptions = (props:any) => {
  const eventOptions = [
    {
      text: "Search by Event ID",
      handler: props.actionProvider.findEventId,
      id: 1,
    },
    // {
    //   text: "Show ongoing Issues",
    //   handler: props.actionProvider.findOngoingCSOs,
    //   id: 2,
    // },
    // {
    //   text: "Show ongoing Maintenances",
    //   handler: props.actionProvider.findOngoingCMRs,
    //   id: 3,
    // },
     {
      text: "Search by last 7 days Events",
      handler: props.actionProvider.findLast7DaysEvents,
      id: 4,
    },
    {
      text: "Search by last 40 days Events",
      handler: props.actionProvider.findLast40DaysEvents,
      id: 5,
    }
   
  ];

 const [activeIndex, setActiveIndex] = useState(null);
const [isDisabled, setIsDisabled] = useState(false);
 const [intitialClassName, setClassName] = useState("option-button");
  const [selectedOption, setSelectedOption] = useState("");

  // Scroll focused element into view when tab navigation occurs
  useEffect(() => {
    const handleFocus = (event: FocusEvent) => {
      const target = event.target as HTMLElement;
      if (target && target.closest('.options-container')) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };

    document.addEventListener('focusin', handleFocus);
    return () => document.removeEventListener('focusin', handleFocus);
  }, []);

  const buttonsMarkup = eventOptions.map((option:any,index:any) => (
    <React.Fragment key={option.id}>
      <button 
        onClick={()=>{
          // Prevent multiple clicks after a selection has been made
          if (isDisabled && activeIndex !== index) {
            return;
          }
          setIsDisabled(!isDisabled);
          setActiveIndex(index);
          setSelectedOption(option.text);
          option.handler();
          setClassName("option-inactive");
        }} 
        className={activeIndex === index?"change-buttons":intitialClassName}  
        aria-pressed={activeIndex === index}
        tabIndex={0} // Ensure all buttons remain in tab order
      >
        {option.text}
      </button>
    </React.Fragment>
  ));

  return (
    <div className="options-container" role="group" aria-label="Event search options">
      {buttonsMarkup}
      {selectedOption && (
        <div aria-live="polite" className="sr-only">
          Selected: {selectedOption}
        </div>
      )}
      <Restart startfromtop={props.actionProvider.handleOptions} showfeedback = {props.actionProvider.showFeedback}/>
    </div>
  );
};

export default EventOptions;
